import React, { useState, useEffect } from "react";
import {
    Row, Col,Button
} from 'reactstrap';
import { Link } from 'react-router-dom';
import FeePaymentTable from './FeePaymentTable';
import { store, getCurrency, getShortDate, toggleOptionsMenu } from '../../Helper';
import { getPayment, getCheckRegister, SendReceipt, deletePayment } from '../../API';
import CheckRegisterCard from '../CheckRegister/CheckRegisterCard';

function Payment(props) {
    const [payment, setPayment] = useState(null);
    const [check, setCheck] = useState(null);
    const [isLoadingPayment, setIsLoadingPayment] = useState(true);

    useEffect(() => {
        fetchPayment();
    }, []);



    const fetchPayment = async () => {
        setIsLoadingPayment(true);

        const paymentResult = await getPayment(props.match.params.paymentId)
        setPayment(paymentResult);
        if (paymentResult.checkRegisterID !== null) {
            const checkResult = await getCheckRegister(paymentResult.checkRegisterID);
            setCheck(checkResult);
        }

        setIsLoadingPayment(false);
    };

    const SendPayReceipt = async () => {


        await SendReceipt(payment.paymentID);



    };

    const deletePaymentprompt = async (paymentId) => {

        if (window.confirm('Are you sure you want to delete this? A record will be kept of the deletion.')) {
            deletePayment(paymentId);
            props.history.push('/admin/payments/');
        }
    };


    const checkRegisterCardOptions = {
        fields: {
            division: true,
            feeType: true,
            checkFrom: true,
            checkNumber: true,
            amount: true,
            checkDate: true,
            receivedDate: true,
            comments: true
        },
        actions: {
            view: false,
            select: false,
            cancel: false
        }
    };

    let paymentJSX = (<div>No Payment Found...</div>);
    if (isLoadingPayment) {
        paymentJSX = (<div>Loading...</div>);
    } else if (payment) {
        const success = payment.isSuccessful ? "Successful" : "Unsuccessful";
        const successIcon = payment.isSuccessful ? (<i className="fas fa-check-square"></i>) : (<i className="far fa-square" ></i >);

        const editURL = '/admin/payments/' + payment.paymentID + '/edit';

        paymentJSX = (
            <div className="item-details">
                <div className="properties">
                    <div className="svg-label tooltip-parent">
                        {successIcon}
                        <span>{success}</span>
                        <div className="tooltip-target">
                            Success
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-money-check-alt"></i>
                        <span>{payment.paymentType?.paymentTypeName ?? 'NA'}</span>
                        <div className="tooltip-target">
                            Payment Type
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-file-invoice-dollar"></i>
                        <span>{getCurrency(payment.paymentAmount)}</span>
                        <div className="tooltip-target">
                            Subtotal
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-hand-holding-usd"></i>
                        <span>{getCurrency(payment.processingFeeAmount || 0)}</span>
                        <div className="tooltip-target">
                            Processing Fee
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-dollar-sign"></i>
                        <span>{getCurrency(payment.paymentAmount + (payment.processingFeeAmount || 0))}</span>
                        <div className="tooltip-target">
                            Total Payment
                        </div>
                    </div>
                    {payment.transactionID ? (
                        <div className="svg-label tooltip-parent">
                            <i className="fas fa-hashtag"></i>
                            <span>{payment.transactionID}</span>
                            <div className="tooltip-target">
                                Transaction ID
                            </div>
                        </div>
                    ) : null}
                    <div className="svg-label tooltip-parent">
                        <i className="far fa-calendar-alt"></i>
                        <span>{getShortDate(payment.paidDate)}</span>
                        <div className="tooltip-target">
                            Paid Date
                        </div>
                    </div>

                    <div>
                        <Button className="btn-block btn-icon"  color="danr-red" onClick={SendPayReceipt} ><span> Send Receipt to Contact</span></Button>
                    </div>
                </div>
                <div className="actions">
                    <div onClick={toggleOptionsMenu} className="action-icon action-dropdown">*
                        <i className="fas fa-ellipsis-h"></i>
                        <div className="action-dropdown-menu">
                            <div className="action-dropdown-menu-item"><Link to={editURL}><span>Edit</span></Link></div>

                            {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                                <div className="action-dropdown-menu-item" onClick={async () => await deletePaymentprompt(payment.paymentID)}><span>Delete</span></div>

                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="payment">
            <Row className="title-row">
                <Col>
                    <h1>Payment</h1>
                </Col>
            </Row>
            <Row className="details-row">
                <Col>
                    {paymentJSX}
                </Col>
            </Row>
            <Row className="check-register-row">
                <Col>
                    {check !== null ? <CheckRegisterCard check={check} options={checkRegisterCardOptions} /> : null}
                </Col>
            </Row>
            <Row>
                <Col>
                    <FeePaymentTable payment={payment} feePayments={payment?.feePayments ?? []} />
                </Col>
            </Row>
        </div>
    );
}

export const viewReceipt = async (paymentId) => {
    console.log('Viewing receipt: ' + paymentId);
}


export default Payment;